.search-results-text__block-heading {
  padding-bottom: var(--qds-main-section-gap-children-unrelated, 2rem);
}
